import React from "react";
import { TextField, Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { COVERAGE_FORM } from "@platform/rfp-core";
import { Link, Typography } from "@platform/design-system";

import { SectionTitle } from "./styledComponents";

const { SINGLE_PLAN, PLAN_DESIGN } = COVERAGE_FORM;

const BenchmarkSection = ({
  handlePlanFormChange,
  currentPlan,
  planName = SINGLE_PLAN,
  link,
  coverageName,
}) => (
  <>
    <SectionTitle>Centro Benchmarked Plan Design</SectionTitle>
    <Box pl={2} pr={2}>
      <Box mt={2} mb={3}>
        <Link
          href={link}
          target="_blank"
          rel="noreferrer"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <strong>View {coverageName} Plan Design - Newly Updated</strong>
          <OpenInNewIcon sx={{ marginLeft: 0.5 }} />
        </Link>
      </Box>
      <TextField
        multiline
        rows={3}
        name={PLAN_DESIGN}
        value={currentPlan[PLAN_DESIGN] || ""}
        onChange={(e) => {
          handlePlanFormChange(e.target, planName);
        }}
        fullWidth
        label={
          <Typography>Indicate any changes to this Plan Option</Typography>
        }
      />
    </Box>
  </>
);

export default BenchmarkSection;
